module.exports = __webpack_public_path__ + "img/pr.1163f571.svg";